import { useState, useRef } from "react";

import { ROUTES } from "app/constants/app";
import { useCompanyCategories } from "app/context/CompanyCategoriesContext/hooks";
import {
  CloseIcon,
  HamburgerIcon,
  HomeIcon,
  theme,
  Typography,
} from "kosmos-ui";
import GrafitoIsotypeIcon from "kosmos-ui/lib/icons/GrafitoIsotype";
import ShopperEntry from "../shopper/ShopperEntry";
import { useLayout } from "app/context/LayoutContext/hooks";
import { useElementSize } from "app/hooks/general";

import {
  NavigationTopbarContainer,
  NavigationTopbarInnerContainer,
  NavigationLink,
  NavigationSidebarContainer,
  ToggleNavSidebarButton,
  NavigationBackdropContainer,
  AnnouncementBarContainer,
  AnnouncementBarInnerContainer,
  AnnouncementCloseButton,
} from "./styles";

export function NavigationTopbar({
  toggleShowSidebar,
}: {
  toggleShowSidebar(): void;
}) {
  const containerRef = useRef(null);

  const { setTopBarHeight } = useLayout();

  useElementSize(containerRef, {
    onUpdate(size) {
      setTopBarHeight(size.height);
    },
  });

  return (
    <NavigationTopbarContainer ref={containerRef}>
      <NavigationTopbarInnerContainer>
        <ToggleNavSidebarButton onClick={toggleShowSidebar}>
          <HamburgerIcon
            color={theme.colorsPalette.white.default}
            height="24px"
            style={{ marginRight: 12 }}
          />
        </ToggleNavSidebarButton>

        <NavigationLink to={ROUTES.home} style={{ margin: 0 }}>
          <GrafitoIsotypeIcon height="32px" />
        </NavigationLink>

        <ShopperEntry />
      </NavigationTopbarInnerContainer>
    </NavigationTopbarContainer>
  );
}

export function NavigationSidebar({
  show,
  toggleShow,
}: {
  show: boolean;
  toggleShow(): void;
}) {
  const { companyCategories, loadingCompanyCategoriesData } =
    useCompanyCategories();

  return (
    <>
      <NavigationSidebarContainer show={show}>
        <NavigationLink to={ROUTES.home} onClick={toggleShow}>
          <HomeIcon height="20px" style={{ marginRight: 8 }} /> Inicio
        </NavigationLink>

        {loadingCompanyCategoriesData ? (
          <p>Cargando categorías...</p>
        ) : (
          companyCategories?.map((companyCategory) => {
            return (
              <NavigationLink
                key={companyCategory._id}
                to={`${ROUTES.companyCategory}/${companyCategory._id}`}
                onClick={toggleShow}
              >
                {companyCategory.name}
              </NavigationLink>
            );
          })
        )}
      </NavigationSidebarContainer>
    </>
  );
}

export function NavigationBackdrop({
  show,
  toggleShowSidebar,
}: {
  show: boolean;
  toggleShowSidebar(): void;
}) {
  return (
    <NavigationBackdropContainer show={show} onClick={toggleShowSidebar} />
  );
}

export function AnnouncementBar() {
  const [show, setShow] = useState(true);

  const { mobile, setAnnouncementBarHeight } = useLayout();

  const containerRef = useRef(null);

  useElementSize(containerRef, {
    onUpdate(size) {
      setAnnouncementBarHeight(size.height);
    },
  });

  function handleCloseClick() {
    setShow(false);
    setAnnouncementBarHeight(0);
  }

  if (!show) return null;

  return (
    <AnnouncementBarContainer ref={containerRef}>
      <AnnouncementBarInnerContainer>
        <AnnouncementCloseButton onClick={handleCloseClick}>
          <CloseIcon height="12px" />
        </AnnouncementCloseButton>

        <Typography
          as="p"
          variant="paragraph3"
          style={{
            color: theme.colorsPalette.white.default,
            width: `calc(100% - ${mobile ? "10px" : "48px"})`,
            textAlign: "center",
            fontSize: mobile ? 12 : 14,
          }}
        >
          Tenemos nuevos lanzamientos!
          <br />
          Descubre nuestras nuevas marcas 2022{" "}
          <span role="img" aria-label="">
            ❤️
          </span>{" "}
        </Typography>
      </AnnouncementBarInnerContainer>
    </AnnouncementBarContainer>
  );
}
